<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 170 170"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="85"
      cy="85"
      r="82"
      stroke="currentColor"
      stroke-width="6"
    />
    <rect
      x="32"
      y="65"
      width="40"
      height="6"
      rx="1"
      fill="currentColor"
    />
    <rect
      x="98"
      y="65"
      width="40"
      height="6"
      rx="1"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M126.198 129C120.913 115.697 104.513 106 85.0989 106C65.6852 106 49.2844 115.697 44 129L51.7532 129C53.3901 126.127 55.8083 123.423 58.9801 121.038C65.4169 116.199 74.6282 113 85.0989 113C95.5697 113 104.781 116.199 111.218 121.038C114.39 123.423 116.808 126.127 118.445 129L126.198 129Z"
      fill="currentColor"
    />
  </svg>
</template>
